<span
  class="tw:block tw:w-full tw:animate-pulse tw:bg-[var(--skeleton-color,var(--color-gray-6))]"
  [class.tw:rounded-full]="shape() === 'circle'"
  [class.tw:rounded]="shape() === 'rect'"
  [style.height]="cssHeight()"
></span>
